import router from '@/router';

const getDefaultState = () => {
    return {
        awcValue: null,
        cookiePreferences: JSON.parse(localStorage.getItem('cookie-preferences')),
        hasAnsweredCookieForm: JSON.parse(localStorage.getItem('cookie-preferences')),
        scriptsMounted: {
            necessary: false,
            analytics: false,
            tracking: false,
            zendesk: false,
            impact: false,
            awin: false,
            ga: false,
            gtm: false,
            trustedshops: false,
            primer: false,
            chargebee: false,
            trustpilot: false,
            stripe: false,
        },
    };
};

const isUSA = process.env.VUE_APP_COUNTRY_ISO === 'USA';
const isDEU = process.env.VUE_APP_COUNTRY_ISO === 'DEU';

function gtag() {
    dataLayer.push(arguments);
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        resetScripts(state) {
            Object.assign(state, getDefaultState().scriptsMounted);
        },
        setAwcValue(state, payload) {
            state.awcValue = payload;
        },
        setCookiePreferences(state, payload) {
            state.cookiePreferences = payload;
            state.hasAnsweredCookieForm = true;
            localStorage.setItem('cookie-preferences', JSON.stringify(payload));
        },
        showCookieBanner(state) {
            state.hasAnsweredCookieForm = false;
        },
        setScriptMounted(state, script) {
            state.scriptsMounted[script] = true;
        },
        setTrustedShops(state, payload) {
            state.scriptsMounted.trustedshops = payload;
        },
    },
    actions: {
        async mountScripts({ state, dispatch }) {
            dispatch('mountImpact');
            if (isUSA || isDEU) {
                dispatch('mountGoogleAnalytics');
                dispatch('mountGoogleTagManager');
            }

            if (state.hasAnsweredCookieForm && state.cookiePreferences.tracking) {
                dispatch('mountGoogleTagManager');
                dispatch('mountAWIN');
            }
        },

        async mountTrustedShops({ state, commit }) {
            if (!state.scriptsMounted.trustedshops && process.env.VUE_APP_TRUSTED_SHOPS_KEY) {
                (function() {
                    window._tsConfig = {
                        'yOffset': '0', /* offset from page bottom */
                        'variant': 'custom_reviews', /* default, reviews, custom, custom_reviews */
                        'customElementId': 'MyCustomTrustbadge', /* required for variants custom and custom_reviews */
                        'responsive': { 'variant': 'custom_reviews', 'customElementId': 'MyMobileCustomTrustbadge' },
                        'trustcardDirection': '', /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */
                        'customBadgeWidth': '', /* for custom variants: 40 - 90 (in pixels) */
                        'customBadgeHeight': '', /* for custom variants: 40 - 90 (in pixels) */
                        'disableResponsive': 'false', /* deactivate responsive behaviour */
                        'disableTrustbadge': 'false', /* deactivate trustbadge */
                    };
                    var _ts = document.createElement('script');
                    _ts.type = 'text/javascript';
                    _ts.charset = 'utf-8';
                    _ts.async = true;
                    _ts.src = `//widgets.trustedshops.com/js/${process.env.VUE_APP_TRUSTED_SHOPS_KEY}.js`;
                    var __ts = document.getElementsByTagName('script')[0];
                    __ts.parentNode.insertBefore(_ts, __ts);
                    commit('setScriptMounted', 'trustedshops');
                })();
            }
        },

        async mountTrustPilot({ state, commit }) {
            if (!state.scriptsMounted.trustpilot) {
                let trustpilot = document.createElement('script');
                trustpilot.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
                trustpilot.type = 'text/javascript';
                trustpilot.async = 1;
                document.getElementsByTagName('body')[0].appendChild(trustpilot);
                commit('setScriptMounted', 'trustpilot');
            }
        },

        async mountStripe({ state, commit }) {
            if (!state.scriptsMounted.stripe) {
                let stripe = document.createElement('script');
                stripe.src = 'https://js.stripe.com/v3/';
                stripe.type = 'text/javascript';
                stripe.async = 1;
                document.getElementsByTagName('body')[0].appendChild(stripe);

                setTimeout(() => {
                    commit('setScriptMounted', 'stripe');
                }, 1000);
            }
        },

        async mountGoogleAnalytics({ state, commit }) {
            if (process.env.VUE_APP_ENABLE_TRACKING === 'true' && !state.scriptsMounted.ga) {
                let googleTag = document.createElement('script');
                googleTag.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.VUE_APP_GA_KEY}`;
                googleTag.type = 'text/javascript';
                document.getElementsByTagName('body')[0].appendChild(googleTag);
                commit('setScriptMounted', 'ga');

                window.GA_TRACKING_ID = process.env.VUE_APP_GA_KEY;
                window.dataLayer = window.dataLayer || [];

                gtag('js', new Date());
                gtag('config', GA_TRACKING_ID, { app_name: 'Freddies Flowers Web App', send_page_view: false });

                router.afterEach((to) => {
                    gtag('config', window.GA_TRACKING_ID, {
                        page_path: to.fullPath,
                        app_name: 'Freddies Flowers Web App',
                        send_page_view: true,
                    });
                });

                router.afterEach((to) => {
                    dataLayer.push({
                        path: to.fullPath,
                    });
                });
            }
        },

        async mountGoogleTagManager({ state, commit }) {
            if (process.env.VUE_APP_ENABLE_TRACKING === 'true' && !state.scriptsMounted.gtm) {
                (function(w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({
                        'gtm.start': new Date().getTime(),
                        event: 'gtm.js',
                    });
                    var f = d.getElementsByTagName(s)[0];
                    var j = d.createElement(s);
                    var dl = l !== 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', process.env.VUE_APP_GTM_KEY);
                commit('setScriptMounted', 'gtm');
            }
        },

        async mountImpact({ state, commit }) {
            if (!state.scriptsMounted.impact) {
                (
                    function(a, b, c, d, e, f, g) {
                        e['ire_o'] = c;
                        e[c] = e[c] || function() {
                            (e[c].a = e[c].a || []).push(arguments);
                        };
                        f = d.createElement(b);
                        g = d.getElementsByTagName(b)[0];
                        f.async = 1;
                        f.src = a;
                        g.parentNode.insertBefore(f, g);
                    }
                )('https://d.impactradius-event.com/A2562045-e0f4-4be5-8234-ecc79ce4fdf01.js', 'script', 'ire', document, window);
                ire('identify', { customerid: '', customeremail: '' });
                commit('setScriptMounted', 'impact');
            }
        },

        async mountAWIN({ state, commit }) {
            if (!state.scriptsMounted.awin && process.env.VUE_APP_AWIN_KEY) {
                var awMastertag = document.createElement('script');
                awMastertag.setAttribute('defer', 'defer');
                awMastertag.src = `https://www.dwin1.com/${process.env.VUE_APP_AWIN_KEY}.js`;
                awMastertag.type = 'text/javascript';
                document.getElementsByTagName('body')[0].appendChild(awMastertag);
                commit('setScriptMounted', 'awin');
            }
        },

        async mountPrimer({ state, commit }) {
            if (!state.scriptsMounted.primer) {
                var primer = document.createElement('script');
                primer.src = `https://assets.primer.io/primer-sdk-web/v1-latest/Primer.min.js`;
                primer.type = 'text/javascript';
                document.getElementsByTagName('body')[0].appendChild(primer);
                commit('setScriptMounted', 'primer');
            }
        },

        async mountChargebee({ state, commit }) {
            if (!state.scriptsMounted.chargebee) {
                var chargebee = document.createElement('script');
                chargebee.src = `https://js.chargebee.com/v2/chargebee.js`;
                chargebee.type = 'text/javascript';
                chargebee.setAttribute('data-cb-domain', process.env.VUE_APP_CHARGEBEE_ENVIRONMENT);
                document.getElementsByTagName('body')[0].appendChild(chargebee);
                commit('setScriptMounted', 'chargebee');
            }
        },
    },
    getters: {
        getAllowsAnalytics: (state) => state.cookiePreferences && state.cookiePreferences.analytics,

        getAwcValue: (state) => state.awcValue,

        getCookiePreferences: (state) => state.cookiePreferences,

        getHasAnsweredCookieForm: (state) => state.hasAnsweredCookieForm,

        getTrustpilotMounted: (state) => state.scriptsMounted.trustpilot,

        isStripeMounted: (state) => state.scriptsMounted.stripe,
    },
};
